import React from 'react';

// A row of photo/video/document thumbnails, tap any to open it full size.
//
// Lived inside AdminDashboard until the homeowner's own work order needed the
// same thing: their photos, per line, on the request they submitted. Same
// component both sides, so a customer sees exactly the thumbnails Julian does.
//
// Cloudinary serves video from a /video/ path and keeps the original
// extension, so either tells us not to try rendering it as an <img>.
export const isVideo = (url) => /\.(mp4|mov|webm|m4v)(\?|$)/i.test(url) || url.includes('/video/');

// A PDF, on the other hand, comes back down the /image/ path — Cloudinary
// treats it as an image it could rasterise. So the path says nothing and only
// the extension does. Without this check a customer's inspection report
// renders as a broken <img> on Julian's lead card.
export const isPdf = (url) => /\.pdf(\?|$)/i.test(url || '');

// Matches DocumentList's icon, because they are the same idea in two places:
// a file you open rather than a picture you look at.
export const IconDoc = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14 2.5H7A1.5 1.5 0 0 0 5.5 4v16A1.5 1.5 0 0 0 7 21.5h10a1.5 1.5 0 0 0 1.5-1.5V7z" />
    <path d="M14 2.5V7h4.5" />
  </svg>
);

// The tile a PDF gets instead of a preview. Deliberately not a rendered first
// page: an inspection report is megabytes and this strip is drawn on a phone,
// on cell data, every time a lead card opens. It says PDF and opens on tap.
export const DocThumb = ({ onClick, title }) => (
  <div className="photo-thumb photo-thumb-doc" onClick={onClick} title={title}>
    <IconDoc />
    <span>PDF</span>
  </div>
);

export default function MediaStrip({ urls, label }) {
  if (!urls?.length) return null;
  const open = (u) => (e) => { e.stopPropagation(); window.open(u, '_blank'); };
  return (
    <div style={{ margin: '8px 0 2px' }}>
      {label && <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 4 }}>{label} ({urls.length})</div>}
      <div className="photo-strip">
        {urls.map((u, i) => isPdf(u) ? (
          <DocThumb key={i} onClick={open(u)} title={u.split('/').pop()} />
        ) : isVideo(u) ? (
          <div key={i} className="photo-thumb photo-thumb-video" onClick={open(u)}>▶</div>
        ) : (
          <img key={i} src={u} alt="" className="photo-thumb" loading="lazy" onClick={open(u)} />
        ))}
      </div>
    </div>
  );
}
